import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IDataContext } from '../../../core/component/list/component.interface';
import { InvoiceDeliveryMethod } from '../../model/const/enum';

@Component({
    selector: 'app-invoice-deliveries',
    templateUrl: './invoice-deliveries.component.html',
    styleUrls: ['./invoice-deliveries.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvoiceDeliveriesComponent implements IDataContext, OnInit {
  constructor() {}

  private _dataContext: InvoiceDeliveryMethod[];
  get dataContext(): InvoiceDeliveryMethod[] {
    return this._dataContext;
  }
  set dataContext(value: InvoiceDeliveryMethod[]) {
    if (value instanceof Array) this._dataContext = value;
    else throw new Error('Invalid data context.');
  }
  get email(): InvoiceDeliveryMethod {
    return (
      this.dataContext.find(x => x === InvoiceDeliveryMethod.EmailWithPDF) ||
      this.dataContext.find(x => x === InvoiceDeliveryMethod.EmailWithoutPDF)
    );
  }
  get mail(): InvoiceDeliveryMethod {
    return this.dataContext.find(x => x === InvoiceDeliveryMethod.Mail);
  }
  get print(): InvoiceDeliveryMethod {
    return this.dataContext.find(x => x === InvoiceDeliveryMethod.Manual);
  }

  get eInvoiceB2B(): InvoiceDeliveryMethod {
    return this.dataContext.find(x => x === InvoiceDeliveryMethod.EInvoiceB2B);
  }

  ngOnInit() {}
}
